import { render, staticRenderFns } from "./AdminMailText.vue?vue&type=template&id=2cc18247&scoped=true&"
import script from "./AdminMailText.vue?vue&type=script&lang=js&"
export * from "./AdminMailText.vue?vue&type=script&lang=js&"
import style0 from "./AdminMailText.vue?vue&type=style&index=0&id=2cc18247&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc18247",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VContainer,VDialog,VRow,VTextField,VTextarea})
